// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Noto Sans', 'Noto Sans Fallback'","fontStyle":"normal"},"className":"__className_50a98f","variable":"__variable_50a98f"};